// import { TFunction } from 'react-i18next';
// import * as Yup from 'yup';
// import { Shape } from '../yup_types';

import { isUSCountry } from '../../utils/utilities';

export enum ADDRESS_FORM_FIELDS {
	LINE_1 = 'AddressLine1',
	LINE_2 = 'AddressLine2',
	CITY = 'AddressCity',
	ZIPCODE = 'AddressZipCode',
	COUNTRY = 'AddressCountry',
	STATE = 'AddressState',
}

export enum ADDRESS_FORM_FIELDS_NAMES {
	LINE_1 = 'NEW_APPLICATION.LABEL.LINE_1',
	LINE_2 = 'NEW_APPLICATION.LABEL.LINE_2',
	CITY = 'NEW_APPLICATION.LABEL.CITY',
	ZIPCODE = 'NEW_APPLICATION.LABEL.ZIPCODE',
	COUNTRY = 'NEW_APPLICATION.LABEL.COUNTRY',
	STATE = 'NEW_APPLICATION.LABEL.STATE',
}

export type AddressFieldsTypes = {
	[ADDRESS_FORM_FIELDS.LINE_1]: string;
	[ADDRESS_FORM_FIELDS.LINE_2]: string;
	[ADDRESS_FORM_FIELDS.CITY]: string;
	[ADDRESS_FORM_FIELDS.ZIPCODE]: string;
	[ADDRESS_FORM_FIELDS.COUNTRY]: string;
	[ADDRESS_FORM_FIELDS.STATE]: string;
}

// @ts-ignore
// export const getAddressValidationSchema = (t: TFunction): Yup.SchemaOf<AddressFieldsTypes> => Yup.object<Shape<AddressFieldsTypes>>().shape({
// 	[ADDRESS_FORM_FIELDS.LINE_1]: Yup.string()
// 		.required(t('NEW_APPLICATION.VALIDATION.LINE_1_REQUIRED')),
// 	[ADDRESS_FORM_FIELDS.CITY]: Yup.string()
// 		.required(t('NEW_APPLICATION.VALIDATION.CITY_REQUIRED')),
// 	[ADDRESS_FORM_FIELDS.ZIPCODE]: Yup.number()
// 		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
// 		.required(t('NEW_APPLICATION.VALIDATION.ZIPCODE_REQUIRED')),
// 	[ADDRESS_FORM_FIELDS.COUNTRY]: Yup.string()
// 		.required(t('NEW_APPLICATION.VALIDATION.COUNTRY_REQUIRED')),
// 	[ADDRESS_FORM_FIELDS.STATE]: Yup.string()
// 		.typeError(t('NEW_APPLICATION.VALIDATION.STATE_REQUIRED'))
// 		.required(t('NEW_APPLICATION.VALIDATION.STATE_REQUIRED')),
// });

export const addressInitialValues: AddressFieldsTypes = {
	[ADDRESS_FORM_FIELDS.LINE_1]: '',
	[ADDRESS_FORM_FIELDS.LINE_2]: '',
	[ADDRESS_FORM_FIELDS.CITY]: '',
	[ADDRESS_FORM_FIELDS.ZIPCODE]: '',
	[ADDRESS_FORM_FIELDS.COUNTRY]: 'US',
	[ADDRESS_FORM_FIELDS.STATE]: '',
};

export type AddressFieldsReturnTypes = {
	line1: string;
	line2: string;
	zipCode: string;
	state: string;
	stateCode: null;
	city: string;
	country: string;
};

export const getFormattedAddressFormFields = (formikValues: { [key: string]: string | null }): AddressFieldsReturnTypes => ({
	line1: formikValues?.[ADDRESS_FORM_FIELDS.LINE_1] ? formikValues?.[ADDRESS_FORM_FIELDS.LINE_1] : null,
	line2: formikValues?.[ADDRESS_FORM_FIELDS.LINE_2],
	zipCode: formikValues?.[ADDRESS_FORM_FIELDS.ZIPCODE].toString(),
	state: isUSCountry(formikValues?.[ADDRESS_FORM_FIELDS.COUNTRY]) ? formikValues?.[ADDRESS_FORM_FIELDS.STATE] : null,
	stateCode: null,
	city: formikValues?.[ADDRESS_FORM_FIELDS.CITY],
	country: formikValues?.[ADDRESS_FORM_FIELDS.COUNTRY],
});

export const convertAddressFieldsToInitial = (data): AddressFieldsTypes => ({
	[ADDRESS_FORM_FIELDS.LINE_1]: data?.address ? data?.address?.line1 : '',
	[ADDRESS_FORM_FIELDS.LINE_2]: data?.address ? data?.address?.line2 : '',
	[ADDRESS_FORM_FIELDS.CITY]: data?.address ? data?.address?.city : '',
	[ADDRESS_FORM_FIELDS.ZIPCODE]: data?.address ? data?.address?.zipCode : '',
	[ADDRESS_FORM_FIELDS.COUNTRY]: data?.address ? data?.address?.country : 'US',
	[ADDRESS_FORM_FIELDS.STATE]: data?.address ? data?.address?.state : '',
});

export const getFormattedAddressData = (data): AddressFieldsReturnTypes => ({
	line1: data?.address?.line1,
	line2: data?.address?.line2,
	zipCode: data?.address?.zipCode,
	state: data?.address?.state,
	stateCode: null,
	city: data?.address?.city,
	country: data?.address?.country,
});
